import { render, staticRenderFns } from "./StaffGroupProfile.vue?vue&type=template&id=374a919b&scoped=true&"
import script from "./StaffGroupProfile.vue?vue&type=script&lang=js&"
export * from "./StaffGroupProfile.vue?vue&type=script&lang=js&"
import style0 from "./StaffGroupProfile.vue?vue&type=style&index=0&id=374a919b&scoped=true&lang=css&"
import style1 from "./StaffGroupProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a919b",
  null
  
)

export default component.exports